import { useEffect, useState } from "react";

import { getAliasesByMenuId } from "../services/aliases";
import { AliasBinding } from "../services/aliases/models";

const useAliases = (organizationBranchId: number) => {
    const [menuId, setMenuId] = useState<number | undefined>();
    const [result, setResult] = useState<AliasBinding[]>([]);
    const [forceReload, setForceReload] = useState(false);

    const reload = async () => {
        const { aliases, err } = await getAliasesByMenuId({
            menuId, organizationBranchId
        });
        setResult(aliases);
        setForceReload(false);
    }
    useEffect(() => {
        reload();
    }, [menuId]);

    useEffect(() => {
        if(!forceReload) return;
        reload();
    }, [forceReload]);

    return [result, setMenuId, setForceReload] as [{alias: string}[], any, any]
};
export default useAliases
